import React from 'react'
import styled from 'styled-components/macro'

import margin from '../../styles/margin'

const getColor = (props) => {
  if (props.secondary) {
    return props.theme.colors.brand.secondary
  } else {
    return props.theme.colors.grey.grey9
  }
}

const Component = styled.p`
  ${margin};

  font-family: 'Pluto Sans', sans-serif;
  /* 14px goes out of range of predegined sizes */
  font-size: ${(props) => (props.small ? '14px' : '16px')};
  line-height: 24px;
  font-weight: ${(props) => (props.bold ? 'bold' : 'normal')};
  color: ${(props) => getColor(props)};
`

const Label = ({ children, ...styles }) => (
  <Component {...styles}>{children}</Component>
)

export default Label
